import isEmpty from 'lodash/isEmpty';
import { ProductImage } from '@sparknz/spark-pattern-library/types/components/Carousels/typings';

import {
  ImageType,
  ProductDetailsQuery,
} from '__generated__/ProductDetailsQuery.graphql';
import { CartProductOfferImages } from 'shared/types/cart';

const CONTENT_DAM_IMAGE_BASE_URL = '/content/dam/shop-journeys';

const COMMON_PLACEHOLDER_IMAGE_URL = `${CONTENT_DAM_IMAGE_BASE_URL}/addons/no-image.svg`;

export function getCartImageUrl(
  productOfferingId: string,
  images: CartProductOfferImages,
) {
  const PLACEHOLDER_IMAGE_URL = `${CONTENT_DAM_IMAGE_BASE_URL}/addons/no-image.svg`;
  const image = images?.find(
    (item) => item.offerId === productOfferingId && item.type === 'PRODUCT',
  );

  return image?.url || PLACEHOLDER_IMAGE_URL;
}

export function getCheckoutImageUrl(
  productOfferingId: string,
  images: CartProductOfferImages,
) {
  const PLACEHOLDER_IMAGE_URL = `${CONTENT_DAM_IMAGE_BASE_URL}/addons/packs.png`;

  const image = images?.find(
    (item) => item.offerId === productOfferingId && item.type === 'FEATURED',
  );

  return image?.url || PLACEHOLDER_IMAGE_URL;
}

export function getImagesByImageType(
  images: ProductDetailsQuery['response']['productData']['offerDetails'][0]['images'],
  imageType: ImageType,
): ProductImage[] {
  if (isEmpty(images)) {
    return [];
  }

  return images
    .filter((image) => image.type === imageType)
    .map((image) => ({
      ...image,
      id: image.imageId,
      defaultUrl: image.defaultUrl || COMMON_PLACEHOLDER_IMAGE_URL,
    }));
}

export function getTransformedProductImageByImageTypes(
  images: ProductDetailsQuery['response']['productData']['offerDetails'][0]['images'],
  imageType: ImageType[],
): ProductImage[] {
  if (isEmpty(images)) {
    return [];
  }

  return images
    .filter((image) => imageType.includes(image.type))
    .map((image) => ({
      id: image.imageId,
      mediaType: image.type === 'GALLERY' ? 'IMAGE' : 'VIDEO',
      defaultUrl: image.defaultUrl || COMMON_PLACEHOLDER_IMAGE_URL,
      description: image.description,
      standardUrl: image.standardUrl,
      thumbnailUrl: image.thumbnailUrl,
      zoomUrl: image.zoomUrl,
    }));
}
